import { createAction } from '@reduxjs/toolkit';
import * as ActionTypes from './types';

export interface GeneralResponse {
    data: GeneralResponseBody;
    errors?: Array<string>;
}
export interface GeneralResponseBody {
    data: Array<QuestionGroupStepType>;
    limit: number;
    message: string;
    page: number;
    totalCount: number;
    totalPages: number;
    warnings: Array<string>;
    count: number;
}

export interface QuestionGroupStepType {
    id: string;
    code: string;
    name: string;
    rank: number;
}

export interface QuestionGroupStepPayload {
    policyTypeCode: string;
    claimCategoryCode: string;
    claimTypeCode: string;
    claimApplicationId: string;
}

export const fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimType =
    createAction<fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeAction>(
        ActionTypes.FETCH_QUESTION_GROUP_STEP_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_AND_CLAIM_TYPE,
    );

export const fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeSuccess =
    createAction<fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeSuccessAction>(
        ActionTypes.FETCH_QUESTION_GROUP_STEP_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_AND_CLAIM_TYPE_SUCCESS,
    );

export const fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeFailed =
    createAction<fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeFailedAction>(
        ActionTypes.FETCH_QUESTION_GROUP_STEP_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_AND_CLAIM_TYPE_FAILED,
    );

export const fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeByClaimApplication =
    createAction<fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeByClaimApplicationAction>(
        ActionTypes.FETCH_QUESTION_GROUP_STEP_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_AND_CLAIM_TYPE_BY_CLAIM_APPLICATION,
    );

export const fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeByClaimApplicationSuccess =
    createAction<fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeByClaimApplicationSuccessAction>(
        ActionTypes.FETCH_QUESTION_GROUP_STEP_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_AND_CLAIM_TYPE_BY_CLAIM_APPLICATION_SUCCESS,
    );

export const fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeByClaimApplicationFailed =
    createAction<fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeByClaimApplicationFailedAction>(
        ActionTypes.FETCH_QUESTION_GROUP_STEP_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_AND_CLAIM_TYPE_BY_CLAIM_APPLICATION_FAILED,
    );

export const clearGroupStep = createAction<clearGroupStepAction | undefined>(
    ActionTypes.CLEAR_QUESTION_GROUP_STEP,
);

export interface fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeAction {
    type: typeof ActionTypes.FETCH_QUESTION_GROUP_STEP_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_AND_CLAIM_TYPE;
    payload: QuestionGroupStepPayload;
}

export interface fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeSuccessAction {
    type: typeof ActionTypes.FETCH_QUESTION_GROUP_STEP_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_AND_CLAIM_TYPE_SUCCESS;
    body: GeneralResponse;
}

export interface fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeFailedAction {
    type: typeof ActionTypes.FETCH_QUESTION_GROUP_STEP_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_AND_CLAIM_TYPE_FAILED;
    body: GeneralResponse;
}

export interface fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeByClaimApplicationAction {
    type?: typeof ActionTypes.FETCH_QUESTION_GROUP_STEP_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_AND_CLAIM_TYPE_BY_CLAIM_APPLICATION;
    policyTypeCode: string | null;
    claimCategoryCode: string | null;
    formTypeCode: string | null;
    claimApplicationId: string;
}

export interface fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeByClaimApplicationSuccessAction {
    type: typeof ActionTypes.FETCH_QUESTION_GROUP_STEP_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_AND_CLAIM_TYPE_BY_CLAIM_APPLICATION_SUCCESS;
    body: GeneralResponse;
}

export interface fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeByClaimApplicationFailedAction {
    type: typeof ActionTypes.FETCH_QUESTION_GROUP_STEP_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_AND_CLAIM_TYPE_BY_CLAIM_APPLICATION_FAILED;
    body: GeneralResponse;
}

export interface clearGroupStepAction {
    type: typeof ActionTypes.CLEAR_QUESTION_GROUP_STEP;
    payload: QuestionGroupStepPayload;
}
